














































import CommonBase from "../CommonBase";
import {Component, Inject, Prop} from "vue-property-decorator";
import Api from "./Api";
import BirthDateInput from "../BirthDateInput.vue";
import PhoneInput from "../phoneinput/Phoneinput.vue";
import CompanySelector from "../companyselector/CompanySelector.vue";
import {Company, DateTime, PendingPerson, PhoneNumber} from "../../modules/models";
import {phoneCheckedLocation} from "@/modules/LoginFlow";
import {ignoreRedundantNavErr} from "@/router";
import Recaptcha from "@/components/prelogin/Recaptcha.vue";

@Component({
    components: {
        "at-birthdate": BirthDateInput,
        "at-phone-input": PhoneInput,
        "at-company-selector": CompanySelector,
        "at-recaptcha": Recaptcha,
    }
})
export default class SignupUnverified extends CommonBase {
    @Inject()
    api!: Api;

    @Prop({default: ""})
    redir!: string;

    loading = false;

    firstName = "";
    lastName = "";
    birthDate: DateTime | null = null;
    phone: PhoneNumber | null = null;
    company: Company | null = null;

    checkFirstnameInput() {
        if(this.firstName.length == 0) {
            return "Fornavn må fylles ut";
        }
        return true;
    }
    checkLastnameInput() {
        if(this.lastName.length == 0) {
            return "Etternavn må fylles ut";
        }
        return true;
    }
    phoneErrors: string[] = [];

    recaptchaOk = false;

    onRecaptchaChecked(v: boolean) {
      this.recaptchaOk = v;
    }

    async signup() {
        this.loading = true;
        try {
            const employedAt: Company[] = [];
            if (this.company != null) {
                employedAt.push(this.company);
            }
            if (this.firstName != null && this.lastName != null && this.phone != null) {
                const toadd = new PendingPerson(null, this.firstName, this.lastName, this.birthDate != null ? this.birthDate.toLocalJsonDate() : null, this.phone, employedAt, DateTime.now(), "", [], []);
                const msg = await this.api.pendingPersonAddPrelogin(toadd);
                if(msg.num == 16) { // SMS sent ok
                    this.snack(`Logg inn med kode eller link mottatt på SMS.`);
                    // Redirect to login page
                    const pendingCreated = DateTime.now().millis().toString();
                    await ignoreRedundantNavErr(this.$router.push(phoneCheckedLocation(this.phone, pendingCreated, undefined, this.redir)));
                } else if(msg.num == 50) {
                    this.phoneErrors = ["Allerede registrert på eksisterende bruker"];
                } else if(msg.num == 51) {
                    this.phoneErrors = ["Allerede registrert, venter på bekreftelse"];
                } else {
                    this.snack(msg.msg);
                }

            } else {
                throw new Error("Navn og telefonnr må være utfyllt");
            }
        } finally {
            this.loading = false;
        }
    }

    snack(txt: string) {
        this.$emit("at-snack", txt);
    }
}
